import { createType } from 'framework/utils/createType';

export const SettingsTabTypes = createType('general', 'templates', 'users');
export type SettingsTabType = typeof SettingsTabTypes[number];
